<div style="
        height: 100%;
        display: flex;
        flex-flow: column;
        background-color: var(--app-surface);
    ">
    <mat-toolbar color="primary" style="position: relative; z-index: 3">
        <span class="left">{{ actualCertification?.name }}</span>
        <button mat-icon-button class="back" (click)="goBack.emit()" color="primary">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div *ngIf="this.displaySpinner">
        <mat-spinner></mat-spinner>
    </div>
    <mat-tab-group *ngIf="!this.displaySpinner  && actualCertification" class="organisation-tabs"
        [backgroundColor]="'primary'">
        <mat-tab label="Übersicht">
            <div class="container">
                <app-image-slider [item]="actualCertification" [category]="'certification'"></app-image-slider>
            </div>
            <div class="padding">
                <div style="display: flex">
                    <div class="left">
                        <div style="display: flex; align-items: center">
                            <div class="pointer" style="width: 45px" (click)="
                                    navigateToOrganisation(
                                        organisation.organisationId
                                    )
                                ">
                                <app-image-slider [organisation]="this.organisation">
                                </app-image-slider>
                            </div>
                            <div style="padding: 1rem">
                                <h1 [class]="
                                        actualCertification?.name.length > 25
                                            ? 'wordellipsis'
                                            : ''
                                    " style="margin: 0">
                                    {{ actualCertification?.name }}
                                </h1>
                                <h3 class="pointer" (click)="
                                        navigateToOrganisation(
                                            organisation.organisationId
                                        )
                                    " [class]="
                                        actualCertification?.organisationName
                                            ?.length > 30
                                            ? 'wordellipsis'
                                            : ''
                                    " style="margin: 0">
                                    {{ actualCertification?.organisationName }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <button mat-raised-button [disabled]="organisation?.contacts.length < 1" color="accent"
                            (click)="requestOffer()" style="margin-right: 1em">
                            Angebot anfragen
                        </button>
                        <button mat-raised-button [disabled]="
                                this.actualCertification?.url == null ||
                                this.actualCertification?.url == undefined ||
                                this.actualCertification?.url == ''
                            " (click)="this.routeToWebsite()" color="accent">
                            Webseite
                        </button>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <br />
                <span style="display: flex; opacity: 0.8">
                    <p class="left" style="margin: 0">
                        Kategorie: {{ getCertType() }}
                    </p>
                    <p *ngIf="this.actualCertification?.editDate" class="middle" style="margin: 0">
                        Seit {{ 'Certification Publish Date' }} auf BIMSWARM
                    </p>
                    <p *ngIf="this.actualCertification?.editDate" class="right" style="margin: 0">
                        Letztes Update: {{ 'Certification Edit Date' }}
                    </p>
                </span>
                <br />
                <mat-divider></mat-divider>
                <br />
                <div *ngIf="actualCertification?.id === 3; else standardOntology">
                    <h3>{{ actualCertification?.organisationName }}</h3>
                    <mat-tab-group class="inner-tab-group">
                        <mat-tab label="Ontology-basiert">
                            <div style="padding-top: 15px;">
                                <app-template-tree-viewer [nodes]="parsedCertificationShape">
                                </app-template-tree-viewer>
                            </div>
                        </mat-tab>
                        <mat-tab label="Gaia-X Compliance (VC)">
                            <div style="padding-top: 15px; padding-bottom: 20px;">
                                <div class="compliance-description">
                                    <h2 style="margin-top: 0">Gaia-X Compliance Verifiable Credential</h2>
                                    <p>Die Gaia-X Compliance stellt die Grundlage für Datensouveränität,
                                        Interoperabilität und Vertrauen innerhalb europäischer Datenökosysteme dar. Um
                                        ein Gaia-X Compliance VC (Verifiable Credential) zu erhalten, werden folgende
                                        Schritte automatisiert durchgeführt:</p>

                                    <div class="step-list">
                                        <div class="step-item">
                                            <mat-icon color="primary">check_circle</mat-icon>
                                            <div class="step-content">
                                                <strong>Notarisierung & Identitätsprüfung</strong>
                                                <span>Der Teilnehmer wird über einen offiziellen Notary Service gegen
                                                    staatliche Register (z.B. Handelsregister) geprüft.</span>
                                            </div>
                                        </div>
                                        <div class="step-item">
                                            <mat-icon color="primary">check_circle</mat-icon>
                                            <div class="step-content">
                                                <strong>SHACL Konformitätsprüfung</strong>
                                                <span>Die bereitgestellte Self-Description wird automatisiert gegen die
                                                    Gaia-X SHACL Shapes (z.B. Legal Person Shape) validiert.</span>
                                            </div>
                                        </div>
                                        <div class="step-item">
                                            <mat-icon color="primary">check_circle</mat-icon>
                                            <div class="step-content">
                                                <strong>Kryptographische Signierung</strong>
                                                <span>Nach erfolgreicher Prüfung wird ein fälschungssicheres Verifiable
                                                    Credential durch den Gaia-X Compliance Service ausgestellt und
                                                    signiert.</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        style="background-color: var(--app-surface); padding: 15px; border-left: 4px solid var(--app-primary); margin-top: 15px;">
                                        <p style="margin: 0; font-size: 0.9em; opacity: 0.8;">
                                            Das resultierende Dokument dient als maschinenlesbarer Nachweis für die
                                            Konformität mit dem Gaia-X Trust Framework und wird im SSI-Wallet des
                                            Teilnehmers hinterlegt.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <ng-template #standardOntology>
                    <h3>Zertifikat</h3>
                    <app-certification-template-tree-viewer [nodes]="parsedCertificationShape">
                    </app-certification-template-tree-viewer>
                </ng-template>
                <br />
                <h3>Beschreibung</h3>
                <p class="word-wrap" [innerHTML]="actualCertification?.description"></p>
                <mat-divider></mat-divider>
                <br />
                <h3>Schlagwörter</h3>
                <mat-chip-list class="chip-list">
                    <mat-chip *ngFor="let item of certificationKeywords">{{
                        item
                        }}</mat-chip>
                </mat-chip-list>
                <br />
            </div>
        </mat-tab>
        <mat-tab *ngIf="actualCertification?.documentFileIds?.length > 0" label="Downloads">
            <div class="padding">
                @if (actualCertification) {
                <app-certification-detail-display-criteria [certification]="actualCertification">
                </app-certification-detail-display-criteria>
                }
            </div>
        </mat-tab>
        <mat-tab label="Zertifikate">
            <div>
                @if (actualCertification?.certificationType !== 'ONTOLOGY_CERT') {
                <app-certification-detail-display-certified-products [certification]="actualCertification">
                </app-certification-detail-display-certified-products>
                }
            </div>
        </mat-tab>
        <!--mat-tab label="Anbieter"> Content 3 </mat-tab-->
    </mat-tab-group>
</div>